import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useUserContext } from "../../contexts/UserContext";
import { LedgerType } from "./types";

export default function EditLedgerTransferModal({ orderNumber, transaction, onClose, refresh }: {
  orderNumber: string; transaction: LedgerType; onClose: () => void; refresh: () => void;
}) {
  const [amount, setAmount] = useState(String(transaction.amount));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const user = useUserContext()?.user;
  const valid = /^\d+(?:\.\d{1,2})?$/.test(amount) && Number(amount) > 0;
  const save = async () => {
    setBusy(true); setError("");
    try {
      await axios.post("/proxy/api/fundstransfer/EditLedgerTransfer", {
        orderNumber, transactionId: transaction.id, expectedAmount: transaction.amount, amount: Number(amount), username: user?.username
      });
      refresh(); onClose();
    } catch (err) {
      setError(axios.isAxiosError(err) ? (err.response?.data?.exceptionMessage || err.response?.data?.message || "Unable to update the transfer.") : "Unable to update the transfer.");
    } finally { setBusy(false); }
  };
  return <Dialog open onClose={busy ? undefined : onClose} fullWidth maxWidth="xs">
    <DialogTitle>Edit ledger transfer</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ mb: 2 }}>Enter the new total for this transfer. Posted transfers update both ledgers.</Typography>
      <TextField label="Amount" value={amount} onChange={e => setAmount(e.target.value)} fullWidth autoFocus inputProps={{ inputMode: "decimal" }} />
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </DialogContent>
    <DialogActions><Button onClick={onClose} disabled={busy}>Cancel</Button><Button variant="contained" onClick={save} disabled={!valid || busy}>Save</Button></DialogActions>
  </Dialog>;
}
